// Dynamic Shopify Price Calculator for RoamHaus with Debug
function calculateTotalPrice() {
    let totalPrice = 0;
    console.log('=== Starting Price Calculation ===');
    
    // Get base price from selected RoamHaus option variant
    const selectedOption = document.querySelector('input[name="Options-1\\A"]:checked') || 
                          document.querySelector('input[name^="Size-"]:checked');
    
    if (selectedOption) {
        const optionValue = selectedOption.value;
        const optionLabel = selectedOption.nextElementSibling?.textContent || '';
        console.log('Selected option value:', optionValue);
        console.log('Selected option label:', optionLabel);
        
        // Try multiple regex patterns for base price
        let basePriceMatch = optionValue.match(/\(\$([0-9,]+)\)/) || 
                           optionLabel.match(/\$([0-9,]+)/) ||
                           optionValue.match(/\$([0-9,]+)/);
        
        if (basePriceMatch) {
            const basePrice = parseFloat(basePriceMatch[1].replace(',', ''));
            totalPrice = basePrice * 100; // Convert to cents
            console.log('Found base price:', basePrice, 'Total so far:', totalPrice);
        } else {
            console.log('No base price found in option selection');
        }
    } else {
        console.log('No option selected');
    }
    
    // Color selection doesn't affect price (it's just a property)
    const selectedColor = document.querySelector('input[name="properties[Color]"]:checked');
    if (selectedColor) {
        console.log('Selected color:', selectedColor.value);
        // Colors don't add to price, just log for reference
    }
    
    // Add all checked addon prices
    const addonCheckboxes = document.querySelectorAll('.add-on-cb input[type="checkbox"]:checked');
    console.log('Found', addonCheckboxes.length, 'checked addons');
    
    addonCheckboxes.forEach(checkbox => {
        const priceElement = checkbox.closest('.add-on-cb').querySelector('.price');
        if (priceElement) {
            const priceText = priceElement.textContent;
            const priceMatch = priceText.match(/\+\$([0-9,]+\.?\d*)/);
            if (priceMatch) {
                const addonPrice = parseFloat(priceMatch[1].replace(',', '')) * 100;
                totalPrice += addonPrice;
                console.log('Found addon addition:', addonPrice / 100, 'Total so far:', totalPrice);
            }
        }
    });
    
    // Convert to dollars and update display
    const totalDollars = totalPrice / 100;
    console.log('Final total:', totalDollars);
    updatePriceDisplay(totalDollars);
    
    return totalDollars;
}



function updatePriceDisplay(total) {
  const totalPriceElement = document.getElementById('total-price');
  const totalPriceOElement = document.getElementById('total-price-o');

  if (totalPriceElement) {
    let finalTotal = total;

    // If total-price-o exists, add the savings difference (divided by 100)
    if (totalPriceOElement) {
      const savingsAttr = totalPriceOElement.getAttribute('savings');
      const savings = savingsAttr ? parseFloat(savingsAttr) / 100 : 0;
      finalTotal += savings;

      totalPriceOElement.textContent = '$' + finalTotal.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    totalPriceElement.textContent = '$' + total.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    console.log('Updated total:', totalPriceElement.textContent);
  } else {
    console.log('Could not find #total-price element');
  }
}




// Universal click handler for the entire product section
function setupClickHandler() {
    const productSection = document.getElementById('ProductInfo-template--18621520445494__main');
    if (productSection) {
        console.log('Setting up click handler on product section');
        
        // Listen for any click in the product section
        productSection.addEventListener('click', function(event) {
            console.log('Click detected on:', event.target.type, event.target.tagName);
            // Recalculate on any click
            setTimeout(calculateTotalPrice, 20);
        });
        
        // Also listen for change events
        productSection.addEventListener('change', function(event) {
            console.log('Change detected on:', event.target.type, event.target.name);
            setTimeout(calculateTotalPrice, 20);
        });
    } else {
        console.log('Could not find product section with ID: ProductInfo-template--18621520445494__main');
        
        // Fallback: try to find any product info container
        const fallbackSection = document.querySelector('.product__info-container');
        if (fallbackSection) {
            console.log('Using fallback product section');
            fallbackSection.addEventListener('click', function(event) {
                console.log('Click detected on:', event.target.type, event.target.tagName);
                setTimeout(calculateTotalPrice, 20);
            });
            
            fallbackSection.addEventListener('change', function(event) {
                console.log('Change detected on:', event.target.type, event.target.name);
                setTimeout(calculateTotalPrice, 20);
            });
        } else {
            console.log('Could not find any product section');
        }
    }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing RoamHaus calculator');
    setupClickHandler();
    calculateTotalPrice();
});

// Manual recalculation function
function recalculatePrice() {
    console.log('Manual recalculation triggered');
    return calculateTotalPrice();
}




 

// Shopify Multi-Product Cart Handler with Color Properties
function addAllToCart() {
    // Validate vehicle fields if they exist on the page (camper template)
    const makeInput = document.getElementById('make');
    const modelInput = document.getElementById('model');
    const yearInput = document.getElementById('year');
    const bedInput = document.getElementById('bed-size');

    const vehicleFieldsExist = makeInput && modelInput && yearInput;

    if (vehicleFieldsExist) {
        const allFilled = makeInput.value.trim() && modelInput.value.trim() && yearInput.value.trim();

        if (!allFilled) {
            if (!makeInput.value.trim()) showFieldError(makeInput, 'Vehicle make is required');
            if (!modelInput.value.trim()) showFieldError(modelInput, 'Vehicle model is required');
            if (!yearInput.value.trim()) showFieldError(yearInput, 'Vehicle year is required');
            if (!bedInput.value.trim()) showFieldError(bedInput, 'Bed size is required');
            return;
        }
    }

    // Get main product variant ID
    const mainVariantInput = document.querySelector('.product-variant-id');
    const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
    
    if (!mainVariantId) {
        console.error('Main variant ID not found');
        return;
    }
    
    // Collect all items to add to cart
    const cartItems = [];
    
    // Collect properties from the form
    const properties = collectFormProperties();
    
    // Add main product with properties
    cartItems.push({
        id: mainVariantId,
        quantity: 1,
        properties: properties
    });
    
    console.log('Main variant ID:', mainVariantId);
    console.log('Properties:', properties);
    
    // Add all selected addon variants (without properties)
    const checkedAddons = document.querySelectorAll('.add-on-cb input[type="checkbox"]:checked');
    console.log('Found', checkedAddons.length, 'checked addons');
    
    checkedAddons.forEach(checkbox => {
        const addonVariantId = checkbox.value || checkbox.id;
        if (addonVariantId && addonVariantId !== checkbox.name) {
            cartItems.push({
                id: addonVariantId,
                quantity: 1
            });
            console.log('Adding addon variant:', addonVariantId);
        }
    });
    
    // Add all items to cart using Shopify Cart API
    if (cartItems.length > 0) {
        addItemsToCart(cartItems);
    }
}

function collectFormProperties() {
    const properties = {};
    
    // Get the main product form (updated for new template ID)
    const productForm = document.getElementById('product-form-template--18621520445494__main');
    if (!productForm) {
        console.log('Product form not found, trying fallback selector');
        // Fallback to any product form
        const fallbackForm = document.querySelector('[id*="product-form"]');
        if (fallbackForm) {
            console.log('Using fallback form');
        } else {
            console.log('No product form found');
            return properties;
        }
    }
    
    const formToUse = productForm || document.querySelector('[id*="product-form"]');
    
    // Collect all properties from inputs with name="properties[...]"
    const propertyInputs = document.querySelectorAll('input[name*="properties["], select[name*="properties["], textarea[name*="properties["]');
    
    propertyInputs.forEach(input => {
        // Only collect checked radio buttons or inputs with values
        if (input.type === 'radio' && !input.checked) return;
        if (input.type === 'checkbox' && !input.checked) return;
        
        // Extract property name from name attribute
        const match = input.name.match(/properties\[(.+?)\]/);
        if (match && input.value.trim() !== '') {
            const propertyName = match[1];
            properties[propertyName] = input.value.trim();
            console.log('Found property:', propertyName, '=', input.value.trim());
        }
    });
    
    // Specifically collect color selection
    const selectedColor = document.querySelector('input[name="properties[Color]"]:checked');
    if (selectedColor) {
        properties['Color'] = selectedColor.value;
        console.log('Selected color:', selectedColor.value);
    }
    
    return properties;
}

function addItemsToCart(items) {
    // Show loading state
    const submitButton = document.getElementById('ProductSubmitButton-template--18621520445494__main');
    const originalText = submitButton ? submitButton.innerHTML : '';
    
    if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span>Adding to cart...</span>';
    }
    
    // Use Shopify Cart API to add multiple items
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: items
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        console.log('Successfully added to cart:', data);
        
        // Optional: Show success message
        showSuccessMessage();
        
        // Optional: Redirect to cart or update cart drawer
        // window.location.href = '/cart';
        
        // Or trigger cart drawer if you have one
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        showErrorMessage('Failed to add items to cart. Please try again.');
    })
    .finally(() => {
        // Restore button state
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
        }
    });
}

function showSuccessMessage() {
    window.location.href = '/cart';
}

function showErrorMessage(msg) {
    // Create and show error notification
    const message = document.createElement('div');
    message.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #e74c3c;
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 9999;
        font-weight: bold;
    `;
    message.textContent = msg;
    document.body.appendChild(message);
    
    setTimeout(() => {
        message.remove();
    }, 5000);
}

// =============================================
// Field Error Helpers
// =============================================

function showFieldError(input, message) {
    clearFieldError(input);

    input.style.border = '1px solid #e74c3c';

    const error = document.createElement('span');
    error.className = 'field-error-msg';
    error.style.cssText = `
        display: block;
        color: #e74c3c;
        font-size: 11px;
        margin-top: 3px;
    `;
    error.textContent = message;

    input.insertAdjacentElement('afterend', error);

    input.addEventListener('input', () => clearFieldError(input), { once: true });
}

function clearFieldError(input) {
    input.style.border = '';
    const existing = input.parentNode.querySelector('.field-error-msg');
    if (existing) existing.remove();
}

// Override the default form submission
function setupCartHandler() {
    const productForm = document.getElementById('product-form-template--18621520445494__main');
    const submitButton = document.getElementById('ProductSubmitButton-template--18621520445494__main');
    
    if (productForm && submitButton) {
        // Prevent default form submission
        productForm.addEventListener('submit', function(event) {
            event.preventDefault();
            addAllToCart();
        });
        
        // Also handle direct button clicks
        submitButton.addEventListener('click', function(event) {
            event.preventDefault();
            addAllToCart();
        });
        
        console.log('Cart handler setup complete');
    } else {
        console.log('Could not find form or submit button, trying fallback selectors');
        
        // Fallback selectors
        const fallbackForm = document.querySelector('[id*="product-form"]');
        const fallbackButton = document.querySelector('[id*="ProductSubmitButton"]');
        
        if (fallbackForm && fallbackButton) {
            fallbackForm.addEventListener('submit', function(event) {
                event.preventDefault();
                addAllToCart();
            });
            
            fallbackButton.addEventListener('click', function(event) {
                event.preventDefault();
                addAllToCart();
            });
            
            console.log('Fallback cart handler setup complete');
        } else {
            console.log('Could not find form or submit button with fallback selectors');
        }
    }
}

// Alternative method: Use FormData to collect all form properties
function addAllToCartWithFormData() {
    const productForm = document.getElementById('product-form-template--18621520445494__main') || 
                      document.querySelector('[id*="product-form"]');
    if (!productForm) return;
    
    // Get main product variant ID
    const mainVariantInput = document.querySelector('.product-variant-id');
    const mainVariantId = mainVariantInput ? mainVariantInput.value : null;
    
    if (!mainVariantId) {
        console.error('Main variant ID not found');
        return;
    }
    
    // Create FormData from the form
    const formData = new FormData(productForm);
    const properties = {};
    
    // Extract properties from FormData
    for (let [key, value] of formData.entries()) {
        if (key.includes('properties[') && value.trim() !== '') {
            const match = key.match(/properties\[(.+?)\]/);
            if (match) {
                properties[match[1]] = value.trim();
            }
        }
    }
    
    // Collect cart items
    const cartItems = [{
        id: mainVariantId,
        quantity: 1,
        properties: properties
    }];
    
    // Add selected addons
    const checkedAddons = document.querySelectorAll('.add-on-cb input[type="checkbox"]:checked');
    checkedAddons.forEach(checkbox => {
        const addonVariantId = checkbox.value || checkbox.id;
        if (addonVariantId && addonVariantId !== checkbox.name) {
            cartItems.push({
                id: addonVariantId,
                quantity: 1
            });
        }
    });
     
    // Add items to cart
    addItemsToCart(cartItems);
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    console.log('Setting up RoamHaus cart handler');
    setupCartHandler();
});

// Manual trigger function
function triggerAddToCart() {
    addAllToCart();
}